import { Component, OnInit } from "@angular/core";
import { LoginService } from "../login.service";
import { PatientsService } from "../patients.service";
import { Patient } from "../patients/patient";
import { takeUntil } from "rxjs/operators";
import { Subject, Subscription } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";
import { pageCount, resolveTotal, shouldShowControls, debouncedSearch } from "../pagination";
import { SPINNER_FADEOUT_DURATION } from "../app.constants";

@Component({
    selector: "app-billing",
    templateUrl: "./billing.component.html",
    styleUrls: ["./billing.component.scss"],
    standalone: false
})
export class BillingComponent implements OnInit {
  private destroy$ = new Subject<void>();

  toggleIdPassport: number = 1;
  toggleBusinessClient: boolean = false; // toggle for search
  invalidi: string = "";
  invalidf: string = "";
  invalidl: string = "";
  id: string;
  first: string;
  last: string;
  phone: string;
  patList: Patient[];
  examList;
  reportList = null;
  statisticsForDoctors = null;
  showIcons = false;
  carderror: string;
  isAWL = false;
  startdate;
  enddate;
  GaArray: any[] = [];
  patExams: any[] = [];
  visitPat: any[] = [];
  AWLStatus = "Waiting";
  AWLExam = "All";
  showpayment: string;
  cardtzsearch: string;
  AWLlist: Patient[];
  awlTime: string;
  selectedPatient: Patient;
  swiping = false;
  awlExamType: string;
  awlLMP;
  awlComment: string;
  chosenAWL: number;
  isReports = false;
  page;
  goEx = { preg: null, exam: null, etype: null };
  fromd: Date;
  tod: Date;
  showhelp = false;
  prn: string;
  code: string;
  typeForm;
  showPat = false;
  showSelectPatient = false;
  openDocumentsAdd: boolean = false;
  isSearching: boolean = false;
  // Set true for the SPINNER_FADEOUT_DURATION window right before isSearching clears, so the spinner fades out instead of popping away.
  isSearchingFading = false;
  // Server-side patient-search pagination. Named currentPage because `page` above is the view name.
  currentPage = 1;
  pageSize = 25;
  totalResults = 0;
  showPaginationControls = false;
  get totalPages(): number {
    return pageCount(this.totalResults, this.pageSize);
  }
  // Repeat the pager under the list only on a full page, so a short last page doesn't show it twice.
  get showBottomPatientPager(): boolean {
    return !!this.patList && this.patList.length >= this.pageSize && this.totalPages > 1;
  }
  // A search has run and returned nothing (patList is null before the first search).
  get showEmptyPatients(): boolean {
    return !!this.patList && !this.patList.length && !this.showPat;
  }
  get showPatientResults(): boolean {
    return !!this.patList && this.patList.length > 0 && !this.showPat;
  }

  // Business clients are identified by a business number rather than an ID/passport.
  patientIdLabel(pat: Patient): string {
    return pat.IsID ? "GUI.Patients.ID" : "GUI.Patients.Passport";
  }

  patientContact(pat: Patient): string {
    return pat.Mobile ? pat.Mobile : pat.Phone;
  }
  // Debounced keystroke search; emits the composed query so an unchanged one is skipped.
  private searchTrigger$ = new Subject<string>();

  constructor(
    public loginService: LoginService,
    public patientsService: PatientsService,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private translate: TranslateService
  ) {
    this.id = "";
    this.first = "";
    this.last = "";
    this.phone = "";
  }

  async ngOnInit() {
    // this.route.params.subscribe((params) => {
    //   // if (params["code"]) {
    //   //   this.code = params["code"];
    //   //   this.loginService.login(undefined, undefined, false, false, undefined, this.code);
    //   // } else {
    //   //   this.loginService.loginMissing();
    //   // }
    //   // this.loginService.onFailedLogin.pipe(takeUntil(this.destroy$)).subscribe(() => {
    //   //   this.router.navigate(["/"]);
    //   // });

    //   this.loginService.onLogin.pipe(takeUntil(this.destroy$)).subscribe(() => {
    //     if (params["pid"]) {
    //       this.patientsService.getPatient(params["pid"], () => {
    //         this.showPat = true;
    //       });
    //     }
    //   });
    // });
    // if (this.patientsService.currentPatient) {
    //   this.showPat = true;
    // }
      this.route.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
      const patientId = params['pid'];

      if (patientId) {
        this.patientsService.getPatient(patientId, () => {
          this.showPat = true;
        });
      } else if (this.patientsService.currentPatient) {
        this.showPat = true;
      }
    });
    debouncedSearch(this.searchTrigger$)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.runSearch());
  }

  ngOnDestroy(): void {
    // Without this the takeUntil(destroy$) guards never fire and the subscriptions leak.
    this.destroy$.next();
    this.patientsService.currentPatient = null;
  }

  search(noawl = false) {
    this.isSearching = true;
    this.showPat = false;
    // A fresh search always starts from the first page.
    this.currentPage = 1;
    this.showPaginationControls = false;
    this.examList = null;
    this.reportList = null;
    this.statisticsForDoctors = null;
    this.showIcons = false;
    this.carderror = null;
    if (this.isAWL && !noawl) {
      this.patList = null;
      if ((this.startdate, this.enddate)) {
        var start =
          this.startdate._i.year +
          "-" +
          (this.startdate._i.month + 1) +
          "-" +
          this.startdate._i.date +
          " 00:00:00.000";
        var end =
          this.enddate._i.year +
          "-" +
          (this.enddate._i.month + 1) +
          "-" +
          this.enddate._i.date +
          " 23:59:59.000";
      }
      this.patientsService
        .getAWL(this.AWLStatus, this.AWLExam, {
          id: this.id,
          first: this.first,
          last: this.last,
          start: start,
          end: end,
          uid: this.loginService.doctor,
        })
        .subscribe(
          (patients: Patient[]) => {
            if (patients.length > 0) {
              this.stopSearching();
              this.GaArray = [];
              patients.forEach((i) => {
                var GAitem = this.lmpGA(i.ExamLMP);
                this.GaArray.push(GAitem);
                if (i.UID) i["nUID"] = i.UID;
              });
            }
            this.AWLlist = patients;
            if (this.cardtzsearch) {
              this.stopSearching();
              this.swiping = false;
              for (let pat of this.AWLlist) {
                let zeros = pat.ID;
                while (zeros.length < 9) zeros = "0" + zeros;
                if (pat.ID == this.cardtzsearch || zeros == this.cardtzsearch) {
                  this.setAWL(pat);
                  this.selectedPatient = pat;
                  if (this.selectedPatient.HMO != "Macabi") {
                    //now for macabi only
                    this.selectedPatient.HMO = "Macabi";
                    this.patientsService
                      .savePatient(
                        this.selectedPatient,
                        this.selectedPatient.PID,
                        this.toggleBusinessClient,
                        this.loginService.premissions.BusinessClients
                      )
                      .subscribe(
                        (data) => {},
                        (error) => {
                          console.log(error);
                        }
                      );
                  }
                  this.showpayment = this.cardtzsearch;
                  this.cardtzsearch = null;
                }
              }
              if (this.cardtzsearch) {
                this.carderror = this.cardtzsearch;
                this.cardtzsearch = null;
              }
            }
          },
          (error) => {
            this.stopSearching();
            console.log(error);
          }
        );
    } else {
      this.patientsService.getPatients(
        this.id,
        this.first,
        this.last,
        this.phone,
        this.loginService.doctor,
        this.toggleBusinessClient,
        (patients: Patient[]) => {
          this.isAWL = false;
          this.applyPatientPage(patients);
        },
        this.currentPage,
        this.pageSize
      );
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.loadPatients();
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.loadPatients();
    }
  }

  // Re-fetch the current page (used by next/previous); keeps the spinner and pagination state in sync.
  loadPatients() {
    this.isSearching = true;
    this.patientsService.getPatients(
      this.id,
      this.first,
      this.last,
      this.phone,
      this.loginService.doctor,
      this.toggleBusinessClient,
      (patients: Patient[]) => {
        this.applyPatientPage(patients);
      },
      this.currentPage,
      this.pageSize
    );
  }

  // Populate the current page and derive pagination state from the backend's exact total.
  private applyPatientPage(patients: Patient[]) {
    this.stopSearching();
    this.patList = [];
    for (let i = 0; i < patients.length; i++) {
      let pat = new Patient();
      pat.asignVals(patients[i]);
      this.patList[i] = pat;
    }
    // COUNT(*) OVER() rides on every row; fall back to page length if it's ever absent.
    this.totalResults = resolveTotal(patients as any);
    this.showPaginationControls = shouldShowControls(this.totalResults, this.pageSize);
  }

  trysearch() {
    this.id = this.id.replace(/\-/g, "_").replace(/\W/g, "").replace(/_/g, "-");
    this.searchTrigger$.next(`${this.id}|${this.first}|${this.last}|${this.phone}`);
  }

  // Debounced search handler - same decision logic trysearch() used to run inline.
  private runSearch() {
    if (!this.isSearchDisabled()) {
      this.search();
    }
  }

  // Hold the spinner at full opacity briefly, then fade it out, instead of removing it the moment data lands.
  private stopSearching() {
    this.isSearchingFading = true;
    setTimeout(() => {
      this.isSearching = false;
      this.isSearchingFading = false;
    }, SPINNER_FADEOUT_DURATION);
  }

  // Single source of truth for the search gate (>=2 chars); shared by auto-search and the Search button.
  // Button gate: the content rule plus an in-flight check, so the button can't be spammed while a search is pending.
  // Kept separate from isSearchDisabled() so a request in flight never blocks the debounced auto-search.
  get isSearchButtonDisabled(): boolean {
    return this.isSearching || this.isSearchDisabled();
  }

  isSearchDisabled(): boolean {
    return !(
      this.id.trim().length > 1 ||
      this.first.trim().length > 1 ||
      this.last.trim().length > 1 ||
      this.phone.trim().length > 1
    );
  }

  setAWL(pat) {
    if (
      (!this.loginService.ishospital || this.loginService.ishospital == "belinson") &&
      pat.Status == "Waiting"
    ) {
      try {
        let edate = new Date(pat.ExamDate);
        this.awlTime =
          edate.getHours() + ":" + (edate.getMinutes() < 10 ? "0" : "") + edate.getMinutes();
      } catch {
        this.awlTime = null;
      }
      this.awlExamType = pat.ExamCode;

      this.awlLMP = pat.ExamLMP;
      this.awlComment = pat.Reason ? pat.Reason : null;
    }
    this.chosenAWL = pat.AWLID;
  }

  lmpGA(lmp) {
    if (!lmp) return "";
    let dt = new Date();
    let days = Math.floor((dt.getTime() - Date.parse(lmp)) / (1000 * 60 * 60 * 24));
    return Math.floor(days / 7) + "w " + (Math.floor(days) % 7) + "d";
  }

  addPatient() {
    this.invalidi = "";
    if (this.id.length < 7 && !this.toggleBusinessClient) {
      this.invalidi = "is-invalid";
      return;
    }
    this.invalidf = "";
    if (this.first == "") {
      this.invalidf = "is-invalid";
      return;
    }
    this.invalidl = "";
    if (this.last == "" && !this.toggleBusinessClient) {
      this.invalidl = "is-invalid";
      return;
    }
    this.selectedPatient = new Patient(
      this.id,
      this.first,
      this.last,
      this.phone,
      "",
      this.toggleBusinessClient
    );
    this.patientsService.setPat(this.selectedPatient);
  }

  clear() {
    this.id = "";
    this.first = "";
    this.last = "";
    this.phone = "";
    this.toggleBusinessClient = false;
    if (this.isAWL) this.search();
  }

  AWL(savestatus = true, type = null) {
    if (!this.enddate && this.startdate) {
      this.enddate = this.startdate;
    } else if (!this.startdate && this.enddate) {
      this.startdate = this.enddate;
    }
    if (savestatus) {
      this.loginService.lastAwlExam = this.AWLExam;
      this.loginService.lastAwl = this.AWLStatus;
      this.loginService.lastAwlStartDate = this.startdate;
      this.loginService.lastAwlEnDate = this.enddate;
    }
    this.isAWL = true;
    this.examList = null;
    this.reportList = null;
    this.statisticsForDoctors = null;
    this.search();
    this.patientsService.openWebSocket(
      !this.loginService.ishospital ? this.loginService.ClinicID : null
    );
  }

  onClosed(closed: string) {
    if (closed) this.selectedPatient = null;
    if (closed == "awl") {
      this.clear();
      this.AWL();
    } else if (this.patList) this.search(); //to refresh details
    this.awlExamType = null;
    this.awlLMP = null;
    this.awlTime = null;
    this.chosenAWL = null;
    this.prn = null;
    this.code = null;
    this.typeForm = null;
    this.showIcons = false;
  }

  setPage(page: string, resetPatient) {
    this.page = page;
    this.showPat = false;
    if (page == "Patients") {
      this.showSelectPatient = true;
    }
    if (page == "Calendar") {
      this.showSelectPatient = false;
    }
    if (resetPatient) {
      this.patientsService.currentPatient = null;
    }
  }

  goToSettings() {
    this.router.navigate(["/settings"]);
  }

  goToBillingReports() {
    this.router.navigate(["/billing-reports"]);
  }

  goAppointments() {
    this.router.navigate(["/appointments"]);
  }

  goMedical() {
    // this.router.navigate(["/billing"]);
  }

  redirectAdministration() {
    const type = this.loginService.isCardio
      ? "cardio"
      : this.loginService.isGastro
      ? "gastro"
      : this.loginService.isEyes
      ? "eyes"
      : "aweb";
    this.http.post("/api/administration", { type }).subscribe((data: string) => {
      window.location.href = data;
    });
  }

  redirectAdministrationPatient() {
    const type = this.loginService.isCardio
      ? "cardio"
      : this.loginService.isGastro
      ? "gastro"
      : this.loginService.isEyes
      ? "eyes"
      : "aweb";
    this.http.post("/api/administration", { type }).subscribe((data: string) => {
      window.location.href = data + "/" + this.patientsService.currentPatient.PID;
    });
  }

  getButtonText(): string {
    let domainUrl = "";
    if (this.loginService.isCardio) {
      domainUrl = this.translate.instant("appointments.gui.labels.domains.Cardio");
    }
    if (this.loginService.isGastro) {
      domainUrl = this.translate.instant("appointments.gui.labels.domains.Gastro");
    }

    if (this.loginService.isEyes) {
      domainUrl = this.translate.instant("appointments.gui.labels.domains.Eyes");
    }
    if (this.loginService.isObgyn) {
      domainUrl = this.translate.instant("appointments.gui.labels.domains.OBGYN");
    }
    return domainUrl;
  }

  goToPatAppointments() {
    this.router.navigate([`/appointments/patient/${this.patientsService.currentPatient.PID}`]);
  }

  getNamePlaceholder(): string {
    let placeholder;
    const firstName = "billing.gui.placeholders.First Name";
    const businessName = "appointments.gui.labels.business name";
    if (this.toggleBusinessClient) {
      placeholder = this.translate.instant(businessName);
    } else {
      placeholder = this.translate.instant(firstName);
    }
    return placeholder;
  }

  getIDPlaceholder(): string {
    let placeholder;
    const ID = "billing.gui.placeholders.ID Number";
    const BNID = "appointments.gui.labels.BN ID Number";
    if (this.toggleBusinessClient) {
      placeholder = this.translate.instant(BNID);
    } else {
      placeholder = this.translate.instant(ID);
    }
    return placeholder;
  }
}
